<template>
  <section
    class="rounded-12 p-2 m-1 shadow-card w-100 max-w-full min-w-0"
    :class="audioBackground"
  >
    <div class="min-w-0">
      <chat-message-player
        :src="src"
        :file-name="name"
        :dark="type === 'OutgoingMessage'"
        :type="type"
        data-test="chat-message-player-view"
      />
      <div
        data-test="audio-info"
        class="flex items-center justify-end text-label-r-13-18 text-fg-base-fg10 mt-2"
      >
        <p>{{ textSize }}</p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ChatMessagePlayer } from '@/shared/components/players'
import { bytesConverter } from '@/shared/utils/bytes-converter'

const props = defineProps<{
  src: string,
  name: string,
  size: number
  type: 'IncomingMessage' | 'OutgoingMessage',
}>()

const audioBackground = computed(() => {
  return props.type === 'IncomingMessage'
    ? 'bg-surf-bg-def'
    : 'bg-comp-messages-bubble-bg-out-def'
})

const textSize = computed(() => bytesConverter(props.size))
</script>
